import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { merge } from "./object.js";
import { compose } from "./fn.js";
import { trim } from "./string.js";
export var presence = function presence(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    amsRule = _ref2[0],
    validationRuleInput = _ref2[1];
  if (amsRule.allowBlank !== false) {
    return [amsRule, validationRuleInput];
  }
  var validationRule = merge(validationRuleInput, {
    presence: {
      allowEmpty: false,
      message: prefixValidationMessage(amsRule.emptyText || amsRule.infoText)
    }
  });
  return [amsRule, validationRule];
};
export var format = function format(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    amsRule = _ref4[0],
    validationRuleInput = _ref4[1];
  if (!amsRule.regex) {
    return [amsRule, validationRuleInput];
  }

  // Ensure that regex is wrapped in slashes (`/`)
  var regexString = /^\/.*\/[dgimsuy]*/.test(amsRule.regex) ? amsRule.regex : "/".concat(amsRule.regex, "/");

  // Split after '/' characters
  var _exec = /\/(.*)\/(.*)/.exec(regexString),
    _exec2 = _slicedToArray(_exec, 3),
    regexRule = _exec2[1],
    regexFlags = _exec2[2];
  var extendedRegexRule = amsRule.allowBlank ? "^\\s*$|" + regexRule : regexRule;
  // Build valid regex with initially assigned flag
  var pattern = new RegExp(extendedRegexRule, regexFlags);
  var validationRule = merge(validationRuleInput, {
    format: {
      pattern: pattern,
      message: prefixValidationMessage(amsRule.regexText || amsRule.invalidText)
    }
  });
  return [amsRule, validationRule];
};
export var inclusion = function inclusion(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
    amsRule = _ref6[0],
    validationRuleInput = _ref6[1];
  if (amsRule.xtype !== "combobox") {
    return [amsRule, validationRuleInput];
  }
  var validValues = (amsRule.data || []).map(function (entry) {
    return trim(entry.key);
  });
  var extraValues = amsRule.allowBlank === true ? [""] : [];
  var validationRule = merge(validationRuleInput, {
    inclusion: {
      within: validValues.concat(extraValues),
      message: prefixValidationMessage(amsRule.invalidText || amsRule.emptyText)
    }
  });
  return [amsRule, validationRule];
};
export var checkbox = function checkbox(_ref7) {
  var _ref8 = _slicedToArray(_ref7, 2),
    amsRule = _ref8[0],
    validationRuleInput = _ref8[1];
  if (amsRule.xtype !== "checkbox" || amsRule.allowBlank) {
    return [amsRule, validationRuleInput];
  }
  var validationRule = merge(validationRuleInput, {
    inclusion: {
      within: [true],
      message: prefixValidationMessage(amsRule.invalidText)
    }
  });
  return [amsRule, validationRule];
};
export var toValidationRule = function toValidationRule(result, item) {
  if (!item.name) {
    return result;
  }
  var validations = compose(format, inclusion, checkbox, presence);
  var _validations = validations([item, {}]),
    _validations2 = _slicedToArray(_validations, 2),
    rule = _validations2[1];
  return merge(result, _defineProperty({}, item.name, rule));
};
var prefixValidationMessage = function prefixValidationMessage(message) {
  return "^".concat(message);
};